import React from 'react'
import { Outlet,Navigate } from "react-router-dom";
import { useSelector } from 'react-redux'
import { useLocation  } from "react-router-dom";
import LoaderComponent from './LoaderComponent';

const PermissionRoutes = ({permission}) => {

    const location  = useLocation();
    const loading   = useSelector((state) => state.userPermissionRoleData.isLoading);
    const list      = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);
    
    if(loading || !list || !list?.data?.rolePermissions || !list?.data?.userPermissions){
        return <LoaderComponent />
    } 

    let roleAccessDenied = false;
    let userAccessDenied = false;
    list?.data?.rolePermissions?.map(rp => rp.key_name === permission ? roleAccessDenied = true : roleAccessDenied);
    list?.data?.userPermissions?.map(up => up.key_name === permission ? userAccessDenied = true : userAccessDenied);
    if(location.pathname === '/web/firmware' || location.pathname === '/web/config-files' || location.pathname === '/web/default-files' || location.pathname === '/web/event-logs'){
        return <Outlet />
    }    
    if(roleAccessDenied || userAccessDenied){
        //Special-case: Except Admin Role all other roles will be redirected to Rehlink User screen.
        if((location.pathname === '/web/users' || location.pathname === '/web/roles' || location.pathname === '/web/permissions') && list?.data?.userDetails.rolename !== 'Admin') {
            return <Navigate to="/web/app/users" />
        } 
        return <Outlet />
    }
    return <Navigate to="/web/access-denied" />
}

export default PermissionRoutes